import React, {useContext} from 'react';
import ConfirmationDialog from '../common/ConfirmationDialog';
import ProjectsContext from './ProjectsContext';

const ConfirmGBUApproversDialog = props => {

   const context = useContext(ProjectsContext);

   return <ConfirmationDialog 
                title="Corporate Approvers Edited"
                subtitle={context.confirmGbuApproversSubtitle}
                body="This change will update across all GBUs. Do you still want to proceed?"
                open={context.confirmGbuApproversDialogOpen}
                onCancel ={()=>context.closeConfirmGbuApproversDialog()}
                onConfirm ={() => context.onConfirmGbuApprovers()}
        />

}

export default ConfirmGBUApproversDialog;